import { useNavigate, useParams } from 'react-router-dom';
import { TableWidget } from '../../../components/table-widget/TableWidget';
import { useOperatorsState } from '../../../services/OperatorsList';
import { StringUtils } from '../../../util/string-utils';
import { useTranslation } from 'react-i18next';
import './MobilesCpe.scss';

type Props = {
  summaryData: any;
};

export const MobilesCpe = (props: Props) => {
  const navigate = useNavigate();
  const { t } = useTranslation();
  const { operatorList, loggedUserData } = useOperatorsState();
  const { operatorId, cpeId } = useParams();

  function goToDevicePage(rowData: any, highlightCve?: boolean) {
    navigate(
      `/operators/${operatorId}/cpe/${cpeId}/d/${rowData.key.ID || rowData.key.deviceId}/devicesPage`,
      highlightCve ? { state: { id: 'high-cve' } } : undefined
    );
  }

  return (
    <section id="mobiles-cpe" className={'w-full'}>
      <div style={{}} className="flex w-full flex-col gap-5 px-5 rounded-xl shadow-md border">
        <TableWidget
          hasSearch={true}
          onRowSelect={goToDevicePage}
          url={`op/account/${cpeId}/mobile-list`}
          countPerPage={10}
          title={t('cpeTabs.mobiles.withApplication')}
          //icon="/icons/pc-grey.svg"
        />
      </div>

      <div style={{}} className="flex w-full flex-col gap-5 px-5 rounded-xl mt-12 shadow-md border">
        <TableWidget
          hasSearch={true}
          onRowSelect={goToDevicePage}
          url={``} //waiting for backend
          countPerPage={10}
          title={t('cpeTabs.mobiles.withThreats')}
          //icon="/icons/pc-grey.svg"
        />
      </div>
    </section>
  );
};
